export const getToken = () => {
  return localStorage.getItem('adminToken');
};

export const getAdminData = () => {
  const data = localStorage.getItem('adminData');
  return data ? JSON.parse(data) : null;
};

const getTokenExpiry = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;

  const expiresAt = getTokenExpiry(token);
  if (expiresAt && expiresAt <= Date.now()) {
    logout();
    return false;
  }

  return true;
};

export const logout = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminData');
};

export const getAuthHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};